module.exports = __webpack_public_path__ + "img/map-tesisler.ee0738d3.svg";